import { FormatAlignJustify } from "@mui/icons-material";
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  addSales: {
    display: "flex",
    justifyContent: "end",
    marginBottom: "20px",
  },
  addSalesTitle: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1B2A4A",
  },
}));
